import { render } from "./AAlert.vue?vue&type=template&id=de81d38e"
import script from "./AAlert.vue?vue&type=script&lang=js"
export * from "./AAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__